<template>
  <div class="fertigation">
    <!-- <NutrientSummary/> -->
    <MainHeader>
      {{ $root.data.fertigation['lang']['name'] }}
    </MainHeader>
    <MainDetails/>
    <div class="tanks">
      <TankItem v-for="item in $root.data.fertigation.data.tanks" :data="item"/>
    </div>
  </div>
</template>

<script>
import TankItem from './../components/fertigation/TankItem';
import MainDetails from './../components/fertigation/MainDetails';
import MainHeader from './../components/common/MainHeader';

export default {
  components: {
    TankItem,
    MainHeader,
    MainDetails,
  }
}
</script>

<style lang="scss" scoped>

.fertigation {
  .head-line {
    margin-bottom: 10px;
  }
}

</style>